/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { BulkCandidateEmailStoreRequest, BulkCandidateEmailStoreResponse } from '../types/BulkCandidateEmailStore'

/**
 * POST /candidates/bulk-email
 * @see backend/nexus/modules/Campaign/Http/Controllers/BulkCandidateEmailController.php BulkCandidateEmailController::store
 */
export async function bulkCandidateEmailStore(
	data: BulkCandidateEmailStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<BulkCandidateEmailStoreResponse>> {
	return axiosInstance.post('/candidates/bulk-email', data, config)
}
